import { render, staticRenderFns } from "./PriceChanged.vue?vue&type=template&id=1669739f&"
import script from "./PriceChanged.vue?vue&type=script&lang=js&"
export * from "./PriceChanged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports